module.exports = __webpack_public_path__ + "static/media/web.83f93a97.svg";